




















import {Component, Prop, Vue} from 'vue-property-decorator'
import Modal from "@/components/modal/Modal.vue";

@Component({
    components: {Modal}
})
export default class ConfirmationModal extends Vue {
    @Prop({
        default: 'Are you sure?'
    })
    title!: string;

    @Prop()
    message!: string;

    @Prop()
    callback!: Function;

    private get portalOrder(): number {
        if (document.getElementById('modal')?.innerHTML !== '') {
            return 2;
        }
        return 1;
    }

    private confirmationOpen: boolean = false;

    private confirmAction() {
        this.callback();
        this.confirmationOpen = false;
    }
}
